<template>
  <div v-if="pendientes.length" class="card mb-3 mb-md-4 border-warning">
    <div class="card-body p-2 p-md-3">
      <h4 class="h6 mb-3">
        <i class="bi bi-bell-fill me-2 text-warning"></i>
        Gastos pendientes de respuesta
        <span class="badge bg-danger ms-1">{{ pendientes.length }}</span>
      </h4>
      <div
        v-for="g in pendientes"
        :key="g.id"
        class="border rounded p-2 p-md-3 mb-2"
      >
        <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
          <div>
            <strong>{{ g.concepto }}</strong>
            <span v-if="g.categoria_nombre" class="badge bg-light text-dark border ms-2">
              {{ g.categoria_nombre }}
            </span>
            <div class="small text-muted">
              {{ formatFecha(g.fecha) }} · {{ g.creado_por }} te ha incluido
              <span v-if="g.grupo_nombre"> en {{ g.grupo_nombre }}</span>
            </div>
            <div class="mt-1">
              Tu parte: <strong>{{ formatImporte(g.cantidad_dividida) }} €</strong>
              <small class="text-muted">
                ({{ formatImporte(g.cantidad) }} € ÷ {{ g.num_participantes || 2 }})
              </small>
            </div>
          </div>
          <div class="d-flex gap-2 align-items-start">
            <button class="btn btn-success btn-sm" :disabled="busy" @click="aceptar(g.id)">
              Añadir a mi lista
            </button>
            <button class="btn btn-outline-secondary btn-sm" :disabled="busy" @click="rechazar(g.id)">
              Descartar
            </button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger mb-0 py-2">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import axios from '../config/axios';

export default {
  name: 'GastosPendientesCompartidos',
  emits: ['aceptado', 'descartado'],
  setup(props, { emit }) {
    const store = useStore();
    const busy = ref(false);
    const error = ref('');
    const pendientes = computed(() => store.getters.gastosPendientesCompartidos);

    const formatImporte = (v) => {
      const n = parseFloat(v);
      return Number.isNaN(n) ? '0.00' : n.toFixed(2);
    };
    const formatFecha = (f) => {
      if (!f) return '';
      return new Date(String(f) + (String(f).includes('T') ? '' : 'T00:00:00')).toLocaleDateString('es-ES');
    };

    const cargar = async () => {
      try {
        await store.dispatch('fetchNotificacionesGrupo');
      } catch {
        /* el badge queda a 0 si falla */
      }
    };

    const withBusy = async (fn, okEmit) => {
      busy.value = true;
      error.value = '';
      try {
        await fn();
        emit(okEmit);
        await store.dispatch('fetchNotificacionesGrupo');
      } catch (err) {
        error.value = err.response?.data?.error || 'No se pudo completar la acción';
      } finally {
        busy.value = false;
      }
    };

    const aceptar = (id) => withBusy(async () => {
      await axios.post(`/api/grupos/notificaciones/gastos/${id}/aceptar`);
      store.commit('removeGastoPendienteCompartido', id);
      try {
        await store.dispatch('fetchUltimosGastos', true);
      } catch {
        /* la lista se recargará al refrescar */
      }
    }, 'aceptado');

    const rechazar = (id) => withBusy(async () => {
      await axios.post(`/api/grupos/notificaciones/gastos/${id}/rechazar`);
      store.commit('removeGastoPendienteCompartido', id);
    }, 'descartado');

    onMounted(cargar);

    return {
      pendientes,
      busy,
      error,
      aceptar,
      rechazar,
      formatImporte,
      formatFecha
    };
  }
};
</script>
